import { Link } from '@vkontakte/vkui';
import { getUrlDisplayPart, SUBSTR_EMAIL_REGEXP, SUBSTR_URL_REGEXP, urlRegexpResultChecker } from '@djs';

/**
 * Ищет вхождения в строке, позволяет заменить их на JSX верстку.
 */
const matchRender = (
  input: string,
  regexp: RegExp,
  replace: (match: RegExpMatchArray) => React.JSX.Element | string,
) => {
  const result: Array<React.JSX.Element | string> = [];

  let cursorIndex = 0;

  for (const match of input.matchAll(regexp)) {
    const index: number = match.index || 0;

    result.push(input.slice(cursorIndex, index));
    result.push(replace(match));

    const matchLength: number = match[0].length;
    cursorIndex = index + matchLength;
  }

  result.push(input.slice(cursorIndex));

  return result;
};

/* Замена переносов строк */

const LINE_BREAKS_REGEXP = {
  regular: /\n/g,
  compact: /\s*\n/g,
};

export const renderLineBreaks = (mode: keyof typeof LINE_BREAKS_REGEXP) => (input: string) => {
  return matchRender(input.trim().replace(/\n\s*\n+/g, '\n\n'), LINE_BREAKS_REGEXP[mode], () => <br />);
};

/* Оборачивание Email в link */

export const renderEmails = (input: string) => {
  return matchRender(input, SUBSTR_EMAIL_REGEXP, (match) => (
    <Link href={`mailto:${match[0]}`} target="_parent" rel="noreferrer noopener">
      {match[0]}
    </Link>
  ));
};

/* Оборачивание url в link */

export const renderUrls = (input: string, processHref: (href: string) => string) => {
  return matchRender(input, SUBSTR_URL_REGEXP, (match) => {
    const result = urlRegexpResultChecker(match);

    const raw = match[0];

    if (!result.valid) {
      return raw;
    }

    return (
      <Link href={processHref(result.href)} target="_blank" rel="noreferrer noopener">
        {getUrlDisplayPart(raw)}
      </Link>
    );
  });
};
